import React from 'react';
import type { DropdownIndicatorProps } from 'react-select';
import { components } from 'react-select';

// this overrides the default dropdown arrow
const DropdownIndicator = (props: DropdownIndicatorProps<any, boolean, any>) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i className="material-symbols-outlined caret-icon">expand_more</i>
            </components.DropdownIndicator>
        )
    );
};

export default DropdownIndicator;
